import { useAuthState } from "react-firebase-hooks/auth";
import { Navigate, useLocation } from "react-router-dom";
import { auth } from "../firebase";
import { ROUTES } from "./Routes";
import { useUserPartnerInformation } from "../hooks/useUserPartnerInformation";
import { Loading } from "../components";

interface ProtectedRouteProps {
  children: JSX.Element;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps): JSX.Element | null => {
  const [user, loadingUser] = useAuthState(auth);
  const location = useLocation();

  const { userPartnerInformation, isLoading } = useUserPartnerInformation(user?.uid);

  if (loadingUser || isLoading) {
    return <Loading />;
  }

  if (!user) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  if (!userPartnerInformation?.data?.partnerId || !userPartnerInformation?.data?.partnerName) {
    // You could redirect or show an access denied page
    // You could redirect or show an access denied page
    return <Navigate to={ROUTES.ACCESS_DENIED} replace />;
  }

  return children;
};

export default ProtectedRoute;
